export class ChatStreamPayload {
  constructor ({
    type,
    content,
    streamId
  }) {
    this.type = type
    this.content = content
    this.streamId = streamId
  }
}
